import { render, staticRenderFns } from "./StoreLogo.vue?vue&type=template&id=115a1249&"
import script from "./StoreLogo.vue?vue&type=script&lang=js&"
export * from "./StoreLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports